var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { ExclusiveBadge as PlusBadge } from '@pegasus/plus';
export var PlusBadgeWrapper = styled(PlusBadge)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    > div {\n        padding: 0;\n        > span {\n            width: 100%;\n        }\n    }\n"], ["\n    width: 100%;\n    > div {\n        padding: 0;\n        > span {\n            width: 100%;\n        }\n    }\n"])));
var templateObject_1;
